{
  "nl": {
    "errors": {
      "audioNotSupported": "Audioformaat wordt niet ondersteund",
      "audioRecordingDeviceError": "Fout met audio-opnameapparaat",
      "connectionAuthenticationFailed": "Verbinding geweigerd door server. Authenticatie mislukt.",
      "connectionRejected": "De verbinding met de server is geweigerd",
      "createFromTemplateFailed": "Fout bij het maken van sjabloon",
      "createItemFailed": "Fout bij het maken van de inhoud",
      "deleted": {
        "header": "Deze inhoud is verwijderd",
        "link": "Naar de fobizz Tools",
        "paragraph": "De persoon die deze inhoud heeft gedeeld, heeft deze zojuist verwijderd. Daarom kan deze niet meer worden weergegeven."
      },
      "downloadFailed": "Het bestand kon niet worden gedownload. Laad de pagina opnieuw en probeer het opnieuw.",
      "error": "Fout",
      "fileAlreadyExists": "Bestand '{filename}' bestaat al",
      "fileUploadFailed": "Fout bij het uploaden van het bestand",
      "forbidden": {
        "header": "Helaas heb je geen toegang tot deze inhoud",
        "link": "Naar de fobizz Tools",
        "paragraph": "Je hebt een uitnodiging via een deellink nodig om deze inhoud te bekijken. Neem contact op met de persoon die je de link heeft gestuurd en vraag om de juiste link."
      },
      "generic": {
        "header": "Er is iets misgegaan!",
        "link": "Naar de fobizz Tools",
        "paragraph": "Er is een fout opgetreden. Probeer het later opnieuw!"
      },
      "h5pContentNotFound": "H5P-inhoud niet gevonden",
      "h5pUploadFailed": "Fout bij het uploaden van het H5P-bestand",
      "liveConnectionLost": {
        "description": "Deze pagina wordt niet meer automatisch bijgewerkt. Laad de pagina opnieuw om weer live-updates te ontvangen.",
        "reload": "Pagina opnieuw laden",
        "title": "Geen live-verbinding"
      },
      "toTeachImportFailed": "Fout bij het importeren van de to teach oefening",
      "toTeachNoH5pDownload": "Deze oefening bevat geen H5P-download",
      "imageUploadFailed": "Fout bij het uploaden van de afbeelding",
      "internalError": "Interne fout opgetreden",
      "invalidUrl": "Dit is geen correcte URL.",
      "jobProcessingFailed": "Fout bij het verwerken van je verzoek",
      "jobProcessingFailedWithDetails": "Fout bij het verwerken van je verzoek: {message}",
      "jobTimeout": "De verwerking duurt ongewoon lang en is afgebroken. Probeer het opnieuw.",
      "noAudioInputDeviceFound": "Geen audio-ingangapparaat gevonden",
      "noVideoInputDeviceFound": "Geen video-ingangapparaat gevonden",
      "notFound": {
        "header": "Dat is helaas niet gelukt!",
        "link": "Naar de fobizz Tools",
        "paragraph": "Het adres dat je zoekt, bestaat niet – of niet meer!"
      },
      "pageLoadFailed": {
        "description": "Laad de pagina opnieuw. Als het probleem aanhoudt, probeer het dan later opnieuw.",
        "title": "Pagina kon niet worden geladen"
      },
      "partnerNotEnabled": "Helaas zijn onze partners voor jou uitgeschakeld.",
      "previewImageGenerationFailed": "Het genereren van de afbeelding is mislukt. Probeer het opnieuw.",
      "previewImageGenerationTimeout": "Het genereren van de afbeelding duurt ongewoon lang en is afgebroken. Probeer het opnieuw.",
      "remixFailed": "Fout bij het remixen van de inhoud",
      "somethingWentWrong": "Er is iets misgegaan",
      "unauthorized": {
        "header": "Dat is helaas niet gelukt!",
        "link": "Naar de fobizz Tools",
        "paragraph": "Log in om toegang te krijgen tot deze pagina!"
      },
      "unknownAudioRecordingError": "Onbekende audio-opnamefout",
      "unknownErrorRefresh": "Onbekende fout opgetreden. Pagina wordt opnieuw geladen!",
      "unknownVideoRecordingError": "Onbekende video-opnamefout",
      "uploadFileTooLarge": "Bestand kan niet worden geüpload omdat het groter is dan {maxSize} MB",
      "uploadTotalSizeExceeded": "Bestand kan niet worden geüpload omdat de totale grootte van {maxTotalSize} MB wordt overschreden",
      "uploadFileTooSmall": "Bestand kan niet worden geüpload omdat het 0 MB groot is.",
      "validationError": "Fout bij de validatie",
      "videoRecordingDeviceError": "Fout met video-opnameapparaat"
    }
  }
}
